import { FilterStageImpl } from './FilterStage';
import { ProjectStageImpl } from './ProjectStage';
import { GroupStageImpl } from './GroupStage';
import { UnwindStageImpl } from './UnwindStage';
import { SortStageImpl } from './SortStage';
import { LimitStageImpl } from './LimitStage';
import { SkipStageImpl } from './SkipStage';
import { ObjectToArrayStageImpl, } from './ObjectToArrayStage';
export const stages = {
    filter: () => new FilterStageImpl(),
    project: () => new ProjectStageImpl(),
    group: () => new GroupStageImpl(),
    unwind: (arrayFieldName) => new UnwindStageImpl(arrayFieldName),
    sort: () => new SortStageImpl(),
    limit: (count) => new LimitStageImpl(count),
    skip: (count) => new SkipStageImpl(count),
    objectToArray: (arrayFieldName, destinationFieldName) => new ObjectToArrayStageImpl(arrayFieldName, destinationFieldName),
};
//# sourceMappingURL=stages.js.map